import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-apollo';
import LoadingOverlay from 'react-loading-overlay';
import BetaPostDetail from './BetaPostDetail';
import { GET_SHARED_BETA_POST_DETAILS } from '../../../graphql-client/queries';
import { loaderStyle } from '../../../utils';

function BetaPostDetailContainer() {
  const params = useParams();
  const betaPostId = params && params.betaPostId;
  const userId = params && params.userId;
  const {
    loading, data: postDetailData,
  } = useQuery(
    GET_SHARED_BETA_POST_DETAILS, {
      variables: { betaPostId, userId },
    },
  );
  return (
    <div>
      <LoadingOverlay
        active={loading}
        spinner
        text=""
        className="containerLoader"
        styles={loaderStyle}
      >
        {
        !loading
        && (
        <BetaPostDetail
          betaPostDetail={postDetailData && postDetailData.shareBetaPost && postDetailData.shareBetaPost.data}
        />
        )
      }
      </LoadingOverlay>
    </div>
  );
}

export default BetaPostDetailContainer;
